<template>
    <div>
        <b-modal 
            no-stacking
            centered
            no-close-on-esc
            no-close-on-backdrop
            hide-header-close
            hide-footer
            v-model="lazadaDropoff.show"
            size="xl"
        >
        <template slot="modal-header">
            <div slot="header" class="bg-white border-0 w-100">
                <div class="row align-items-center">
                    <div class="col-6">
                        <h3 class="mb-0">นำเข้าพัสดุ Lazada Dropoff
                        <span class="text-danger"></span></h3>
                    </div>
                    <div class="col-6 text-right">
                        <a :href="customDropoff.manual" v-if="customDropoff.manual" target="_blank">คู่มือการใช้งาน  </a>  
                        <a :href="customDropoff.vdoHowTo"  v-if="customDropoff.vdoHowTo" target="_blank">VDO การใช้งาน</a>
                    </div>
                </div>
            </div>
        </template>
            <card shadow type="secondary" class="m--4">
                <div class="row">
                    <div class="col-md-12">
                        <ScanTrackingLazadaDropoff
                            ref="lazadaDropoff"
                            :isLoading="lazadaDropoff.isLoadingLazadaDropoff"
                            isPlaceholder="LEXDO480522KRFX7A"
                            :isError="lazadaDropoff"
                            :isTracking="lazadaDropoff"
                            courierCode="LZDS"
                            :shopId="shopId"
                            @checkTracking="checkTrackingLazadaDropoff()"
                            @checkTrackingRegx="checkTrackingRegx( $event )"
                            v-if="lazadaOrder.length +cartLazadaDropoff.length < (customDropoff.limit || 50)"
                        />
                        <div class="container-fluid px-5">
                            <div class="row">
                                <h4>รายการพัสดุ ({{ lazadaOrder.length }}) ชิ้น</h4>    
                            </div>
                            <div class="row">
                                <div class="scroll-table scroll-bar-pop m-h-380 scrollbar-style table-responsive">
                                    <table class="table">
                                        <thead class="thead-light">
                                            <tr class="text-center">
                                                <th>#</th>
                                                <th>Tracking no.</th>
                                                <th>จัดการ</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-for="(item,index) in lazadaOrder">
                                                <tr class="text-center table-white" :key="index">
                                                    <td>{{index + 1}}</td>
                                                    <td>{{item.dropoff_tracking_code}}</td>
                                                    <td>
                                                        <div class="d-flex">
                                                            <button
                                                                class="btn btn-link text-danger p-2 hvr-grow"
                                                                @click="deleteLazadaOrder( index )"
                                                            >
                                                                <i class="far fa-trash-alt"></i>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="mt-4 w-100">
                                <div class="row text-center">
                                    <div class="col-12">
                                        <b-button 
                                            class="px-5 mx-4" 
                                            variant="secondary"
                                            @click="clearLazadaDropoff()"
                                        > 
                                            <i class="fas fa-circle-notch fa-spin" v-if="isLoadCancelBatch"></i>
                                            ยกเลิก
                                        </b-button>
                                        <b-button
                                            class="px-5 mx-4"
                                            variant="success"
                                            @click="$emit('confirmCreateLazadaDropoff' , lazadaOrder)"
                                        > ยืนยัน
                                        </b-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </card>
        </b-modal>
    </div>
</template>

<script>
import ScanTrackingLazadaDropoff from '@/components/custom/pos/ScanTrackingLazadaDropoff'
import customTheme from "@/config/POPTheme";
import { sound } from '@/plugins/soundEffect.js'
import { searchTrackingLazadaDropoff } from "@/axios/search.js";
import { setCookie, getCookie } from "@/helpers/util"

export default {
    name: 'LazadaDropoff' ,
    props: {
        lazadaDropoff: Object,
        count: Number,
        addressFrom: Object,
        cartLazadaDropoff: Array,
        shopId: [Number, String]
    },
    components:{
        ScanTrackingLazadaDropoff
    },
    data(){
        let customDropOption = customTheme.customDropoffOption || {
            'LZDS': {}
        }
        return {
            isLoadCancelBatch: false,
            lazadaOrder: [],
            batchId: '',
            customDropoff: {
                manual: customDropOption.LZDS.manual,
                vdoHowTo: customDropOption.LZDS.vdoHowTo,
                limit: customDropOption.LZDS.limit
            }
        }
    },
    methods:{
        async checkTrackingLazadaDropoff(){
            this.lazadaDropoff.isLoadingLazadaDropoff = true
            this.lazadaDropoff.errorMsg = '';
            if( (this.lazadaOrder.length+this.cartLazadaDropoff.length) > (this.customDropoff.limit-1) ) {
                sound('beepFail')
                this.lazadaOrder.errorMsg = `ไม่สามารถสร้างรายการ Shipment ได้ เนื่องจาก BatchId รองรับจำนวน Shipment ได้สูงสุด ` + this.customDropoff.limit + ` Shipment`;
                this.lazadaOrder.isLoadingLazadaDropoff = false
                return false
            }
            let uniqueTracking = this.lazadaOrder.filter( lazada => {
                return lazada.dropoff_tracking_code === this.lazadaDropoff.trackingCode
            })
            let uniqueCartTracking = this.cartLazadaDropoff.filter( lazada => {
                return lazada.dropoff_tracking_code === this.lazadaDropoff.trackingCode
            })

            if( uniqueTracking.length > 0 || uniqueCartTracking.length > 0 ){
                sound('beepFail')
                this.lazadaDropoff.errorMsg = `ไม่สามารถสร้างรายการ Shipment ได้ เนื่องจากหมายเลขพัสดุ ${this.lazadaDropoff.trackingCode} นี้ ถูกใช้งานไปแล้ว`;
                this.lazadaDropoff.isLoadingLazadaDropoff = false
                return false
            }

            await searchTrackingLazadaDropoff( this.lazadaDropoff.trackingCode ).then( tracking_code => {
                sound('positiveBeep')
                this.lazadaOrder.push( this.setFormatOrderLazadaDropoff( tracking_code ) );
                if (/^TH\w+/ig.test(this.lazadaDropoff.trackingCode)) {
                    this.lazadaDropoff.showFlashExample = false;
                    setCookie('HIDE_LZDS_FLE', true, 1);
                }
                this.clearForm();
                this.$refs.lazadaDropoff.$refs.searchTracking.focus();
            }).catch(e => {
                sound('beepFail')
                this.lazadaDropoff.errorMsg = e;
                this.lazadaDropoff.isLoadingLazadaDropoff = false
            });
        },
        async deleteLazadaOrder( indexOfOrder ){
            this.lazadaOrder.splice( indexOfOrder , 1)
        },
        async clearLazadaDropoff(){
            this.lazadaOrder = [];
            this.lazadaDropoff.show = false
            this.clearForm()
        },
        clearForm(){
            this.lazadaDropoff.isLoadingLazadaDropoff = false
            this.lazadaDropoff.trackingCode = '';
            this.lazadaDropoff.errorMsg = '';
        },
        setFormatOrderLazadaDropoff( lazadaTrackingCode ){
            let count = this.count

            let lazadaDropoff = {
                error:{
                    status: false,
                    data: [],
                    msg: null
                },
                type : 'ship',
                dropoff_type : 'LAZADA_DROPOFF',
                num : 1,
                name : 'LAZADA DROPOFF',
                key: "LZDS", 
                parcel: {
                    weight: 1,
                    width: 1,
                    length: 1,
                    height: 1,
                    key_size: '',
                    name: '-',
                    weightKG: 0,
                },
                price : '0.00',
                rate_remote_area : '0.00',
                cross_price : '0.00',
                cod_amount : '0.00',
                dropoff_tracking_code: lazadaTrackingCode,
                consignment_no_ref: '',
                check : count++,
                from: {
                    name: this.addressFrom.name,
                    address: this.addressFrom.address,
                    district: this.addressFrom.district,
                    state: this.addressFrom.state,
                    province: this.addressFrom.province,
                    postcode: this.addressFrom.postcode,
                    tel: this.addressFrom.tel
                },
                to: {
                    name: lazadaTrackingCode,
                    address: '-',
                    district: '-',
                    province: '-',
                    state:'-',
                    postcode: '10000',
                    tel: '-',
                }
            }

            this.$emit('update:count', count)

            return lazadaDropoff
        },
        checkTrackingRegx( event ){
            this.lazadaDropoff.trackingCode = event.target.value.toUpperCase()
            if (this.lazadaDropoff.trackingCode) {
                this.lazadaDropoff.trackingCode = this.lazadaDropoff.trackingCode.trim().split(' ')[0]
            }
            if (/^TH/ig.test(this.lazadaDropoff.trackingCode)) {
                if (!getCookie('HIDE_LZDS_FLE')) {
                    this.lazadaDropoff.showFlashExample = true;
                } else {
                    this.lazadaDropoff.showFlashExample = false;
                }
                this.lazadaDropoff.warningMsg = "กรณีแสกนรับพัสดุ Flash Express กรุณาตรวจสอบใบปะหน้าหน้าพัสดุว่าเป็นประเภท Drop-off (DO/DOF) เท่านั้น กรณียิงรับพัสดุ Pickup (PU) จะไม่ได้รับค่าคอมมิชชั่น";
            } else {
                this.lazadaDropoff.warningMsg = '';
            }
             let validateBarcode = /((^(LEXDO|LEXPU|KERDO|KERPU)\d+$)|(^TH\w+$)|(^510\d+$))/i.test(this.lazadaDropoff.trackingCode)
            if( validateBarcode === false && false){
                this.lazadaDropoff.errorMsg = 'หมายเลขพัสดุไม่ถูกต้อง';
                return false;
            }
        }
    }
}
</script>
